import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-align_top_and_bottom_center",
  "use": "icon-align_top_and_bottom_center-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-align_top_and_bottom_center\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n<path d=\"M6,11H18v1.5H6Zm4-3h2L9,10,6,8H8V5h2Zm6,0h2l-3,2L12,8h2V5h2ZM10,19H8V16H6l3-2,3,2H10Zm6,0H14V16H12l3-2,3,2H16Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol